import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5d879804")

_pushScopeId("data-v-5d879804")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "新增收入", -1)
const _hoisted_4 = { class: "mar-r-8 mar-t-12" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "导出", -1)
const _hoisted_6 = {
  key: 0,
  class: "flex button-group flexC"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "作废", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "审核", -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "反审核", -1)
const _hoisted_13 = { key: 2 }
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "恢复", -1)
const _hoisted_15 = { class: "flex flexR mar-t-22" }
const _hoisted_16 = { class: "flex flexC" }
const _hoisted_17 = { class: "c-ff" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_19 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
const _hoisted_20 = {
  border: "0",
  cellspacing: "0",
  cellpadding: "0"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      (_ctx.roleList.create)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "mar-r-8 bg-red mar-t-12",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeIncome(1,0)))
          }, {
            default: _withId(() => [
              _hoisted_3
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.screenParameter.type,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.screenParameter.type = $event)),
          placeholder: "请选择",
          clearable: "",
          class: "mar-r-8",
          style: {"width":"114px"}
        }, {
          default: _withId(() => [
            _createVNode(_component_el_option, {
              label: "收入日期",
              value: 1
            }),
            _createVNode(_component_el_option, {
              label: "创建日期",
              value: 2
            }),
            _createVNode(_component_el_option, {
              label: "审核日期",
              value: 3
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_date_picker, {
          modelValue: _ctx.screenParameter.time,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.screenParameter.time = $event)),
          type: "daterange",
          align: "right",
          "unlink-panels": "",
          disabled: !_ctx.screenParameter.type,
          "range-separator": "-",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          shortcuts: _ctx.shortcuts,
          onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.screenChange($event, 'time')))
        }, null, 8, ["modelValue", "disabled", "shortcuts"])
      ]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.screenParameter.status,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.screenParameter.status = $event)),
        placeholder: "状态",
        clearable: "",
        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.selectChange($event, 'status'))),
        class: "mar-r-8 mar-t-12",
        style: {"width":"100px"}
      }, {
        default: _withId(() => [
          _createVNode(_component_el_option, {
            label: "待审核",
            value: "1"
          }),
          _createVNode(_component_el_option, {
            label: "已审核",
            value: "2"
          }),
          _createVNode(_component_el_option, {
            label: "已作废",
            value: "3"
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.screenParameter.income_type,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.screenParameter.income_type = $event)),
        placeholder: "收入类型",
        clearable: "",
        onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.selectChange($event, 'status'))),
        class: "mar-r-8 mar-t-12",
        style: {"width":"142px"}
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.type, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.screenParameter.income_collection,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.screenParameter.income_collection = $event)),
        placeholder: "收款方式",
        clearable: "",
        onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.selectChange($event, 'status'))),
        class: "mar-r-8 mar-t-12",
        style: {"width":"114px"}
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.zf, (item, index) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: index,
              label: item.basicset_name,
              value: item.basicset_id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        style: {"width":"202px"},
        modelValue: _ctx.screenParameter.search,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.screenParameter.search = $event)),
        placeholder: "付款方/电话/关联单据",
        clearable: "",
        "suffix-icon": "el-icon-search",
        class: "mar-t-12",
        onChange: _cache[12] || (_cache[12] = ($event: any) => (_ctx.selectChange($event,'search')))
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "mar-l-9 bg-red mar-t-12",
        onClick: _ctx.exportChange
      }, {
        default: _withId(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass,
      "show-summary": "",
      "summary-method": _ctx.getSummaries
    }, {
      default: _withId(() => [
        _createVNode(_component_el_table_column, {
          label: "收入日期",
          align: "center",
          "min-width": "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "text-center c-red purchaes_number",
              onClick: ($event: any) => (_ctx.detailClick(scope.$index))
            }, _toDisplayString(scope.row.income_time_text), 9, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "收入类型",
          align: "center",
          "min-width": "60"
        }, {
          default: _withId((scope) => [
            _createVNode("div", null, _toDisplayString(scope.row.income_collection_text), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "关联单据",
          align: "center",
          "min-width": "80"
        }, {
          default: _withId((scope) => [
            _createVNode("div", {
              class: "text-center c-red purchaes_number",
              onClick: ($event: any) => (_ctx.getOrderCarinfo(scope.row))
            }, _toDisplayString(scope.row.ordersn), 9, ["onClick"])
          ]),
          _: 1
        }),
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128)),
        _createVNode(_component_el_table_column, {
          label: "操作",
          align: "center",
          "min-width": "120"
        }, {
          default: _withId((scope) => [
            (scope.row.is_use == 1)
              ? (_openBlock(), _createBlock("div", _hoisted_6, [
                  (scope.row.income_status == 1)
                    ? (_openBlock(), _createBlock("div", _hoisted_7, [
                        (_ctx.roleList.edit)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: ($event: any) => (_ctx.changeIncome(2,scope.$index))
                            }, {
                              default: _withId(() => [
                                _hoisted_8
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.roleList.void)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 1,
                              onClick: ($event: any) => (_ctx._incomeUpstar(scope.row.income_id, 1))
                            }, {
                              default: _withId(() => [
                                _hoisted_9
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.roleList.check)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 2,
                              onClick: ($event: any) => (_ctx._incomeUpstar(scope.row.income_id, 2))
                            }, {
                              default: _withId(() => [
                                _hoisted_10
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.income_status == 2)
                    ? (_openBlock(), _createBlock("div", _hoisted_11, [
                        (_ctx.roleList.recheck)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: ($event: any) => (_ctx._incomeUpstar(scope.row.income_id, 2))
                            }, {
                              default: _withId(() => [
                                _hoisted_12
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (scope.row.income_status == 3)
                    ? (_openBlock(), _createBlock("div", _hoisted_13, [
                        (_ctx.roleList.recovery)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              onClick: ($event: any) => (_ctx._incomeUpstar(scope.row.income_id, 2))
                            }, {
                              default: _withId(() => [
                                _hoisted_14
                              ]),
                              _: 2
                            }, 1032, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "header-cell-style", "summary-method"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode("div", _hoisted_15, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20,50,100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.diatitle,
      "model-value": _ctx.dialog_model == 'add' || _ctx.dialog_model == 'edit',
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      footer: _withId(() => [
        _createVNode("div", _hoisted_16, [
          _withDirectives(_createVNode(_component_el_button, {
            class: "bg-red mar-r-16",
            onClick: _ctx._form_submit
          }, {
            default: _withId(() => [
              _createVNode("span", _hoisted_17, _toDisplayString(_ctx.diatitle), 1)
            ]),
            _: 1
          }, 8, ["onClick"]), [
            [_directive_loading, _ctx.form_load]
          ]),
          _createVNode(_component_el_button, {
            onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.dialog_model = ''))
          }, {
            default: _withId(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          ref: "formRef",
          model: _ctx.form,
          rules: _ctx.form_rules,
          "label-width": "100px",
          style: {"width":"850px","margin":"0 auto"},
          inline: true
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              label: "收入日期",
              prop: "income_time_text"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.form.income_time_text,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.income_time_text = $event)),
                  type: "date",
                  style: {"width":"300px"},
                  placeholder: "选择日期",
                  onChange: _cache[14] || (_cache[14] = ($event: any) => (_ctx.screenChange($event, 'formtime')))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收入类型",
              prop: "income_type"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.income_type,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.income_type = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"300px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.specialType, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.basicset_name,
                        value: item.basicset_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "金额",
              prop: "income_price"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"300px"},
                  modelValue: _ctx.form.income_price,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.form.income_price = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "收款方式",
              prop: "income_collection"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.income_collection,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.form.income_collection = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"300px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.specialZf, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.basicset_name,
                        value: item.basicset_id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "付款方" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"300px"},
                  modelValue: _ctx.form.income_payer,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.form.income_payer = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "联系电话" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"300px"},
                  modelValue: _ctx.form.income_phone,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.form.income_phone = $event)),
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "经手人" }, {
              default: _withId(() => [
                _createVNode(_component_el_select, {
                  modelValue: _ctx.form.admin_id,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.form.admin_id = $event)),
                  placeholder: "请选择",
                  clearable: "",
                  class: "mar-r-8",
                  style: {"width":"300px"}
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectList.staff, (item, index) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: index,
                        label: item.nickname,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "备注" }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"400px"},
                  modelValue: _ctx.form.income_desc,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.form.income_desc = $event)),
                  type: "textarea",
                  row: "3",
                  placeholder: "请输入"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"]), [
          [_directive_loading, _ctx.dialog_load]
        ])
      ]),
      _: 1
    }, 8, ["title", "model-value", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "记账详情",
      "model-value": _ctx.dialog_model == 'detail',
      center: "",
      width: 1000,
      "before-close": ()=>{_ctx.dialog_model = false}
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_19, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.detailTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["model-value", "before-close"]),
    _createVNode(_component_el_dialog, {
      title: "工单详情",
      modelValue: _ctx.dialogFormVisible,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.dialogFormVisible = $event)),
      onClosed: _ctx.handleClose,
      center: "",
      width: 1000
    }, {
      default: _withId(() => [
        _createVNode("table", _hoisted_20, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.dialogTable, (items, index) => {
            return (_openBlock(), _createBlock("tr", { key: index }, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(items, (item, idx) => {
                return (_openBlock(), _createBlock("td", { key: idx }, _toDisplayString(item), 1))
              }), 128))
            ]))
          }), 128))
        ]),
        (_ctx.orderDetail.order_offer_project.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 0,
              data: _ctx.orderDetail.order_offer_project,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 1),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.projectColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.order_offer_mountings.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 1,
              data: _ctx.orderDetail.order_offer_mountings,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 2),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.partsColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.mountings_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 2,
              data: _ctx.orderDetail.mountings_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 3),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.mountingsCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.else_cost.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 3,
              data: _ctx.orderDetail.else_cost,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "show-summary": "",
              "summary-method": (item) => _ctx.getSummariesDia(item, 4),
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.elseCostColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "summary-method", "header-cell-style"]))
          : _createCommentVNode("", true),
        (_ctx.orderDetail.settlement.length > 0)
          ? (_openBlock(), _createBlock(_component_el_table, {
              key: 4,
              data: _ctx.orderDetail.settlement,
              stripe: "",
              style: {"width":"100%"},
              class: "mar-b-10",
              "header-cell-style": _ctx.headClass
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.settlementColumn, (item, index) => {
                  return (_openBlock(), _createBlock(_component_el_table_column, {
                    align: "center",
                    prop: item.prop,
                    label: item.label,
                    "min-width": item.width,
                    key: index
                  }, null, 8, ["prop", "label", "min-width"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["data", "header-cell-style"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"])
  ]))
})